module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAASCAYAAABIB77kAAAAz0lEQVQ4jWP8DwQMdARMIMLFO5LB1iUYLACiCbHt3UIY1PXtwfpIBiAfqunZ/ScH2DgHkawH7EMJcVGcDgL5Bhc4vGctyR4EW3hw1xqcCv79wx3F+ByD10JyfYHPMXgtJNcX5AQpCyGNhByDLTqK66djiPU2ZoJplCDFlg1AjsGVPXA5BmY4Vj6h5G3nGkxWlgGBorppGGIMhDRR2zHDP5UyEdJI7YzPQG5cgAA5ZTDYh6ysrODSH1/2wMaWlZEi2YOMIFtJDxfyARM9LQMBABQKBcxy+W5gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/kxtb1-1 (2).png
// module id = 747
// module chunks = 0